import React from 'react'
import { Radio } from 'atoms/Radio'
import translate from 'core/translate'
import { cn } from 'ethcss'
import styles from './deviceSettings__browserMode.jcss'
import { Typography } from 'atoms/Typography'
import grid from '../../../blocks.simple/grid/grid.jcss'
import Checkbox from '../../../blocks.simple/checkbox/checkbox'

const DeviceSettingsBrowserMode = (p_: {
    enabled: boolean
    browserSettings: {
        openBrowser: string
        flags: string[]
    }
    onChange: (value: any, field: string) => void
    platform: string
}) => {
    if (!p_.enabled) {
        return null
    }

    function builtInBrowser() {
        p_.onChange(
            {
                ...p_.browserSettings,
                openBrowser: 'internal',
            },
            'browserSettings'
        )
    }

    function externalBrowser() {
        p_.onChange(
            {
                ...p_.browserSettings,
                openBrowser: 'external',
            },
            'browserSettings'
        )
    }

    function onChangeFlag(selected: boolean, flag: string) {
        if (!p_.browserSettings.flags) return

        let flags: string[] = []

        if (selected && p_.browserSettings.flags && !p_.browserSettings.flags.includes(flag)) {
            flags = [...p_.browserSettings.flags, flag]
        } else {
            flags = p_.browserSettings.flags.filter((item) => flag !== item)
        }

        p_.onChange(
            {
                ...p_.browserSettings,
                flags,
            },
            'browserSettings'
        )
    }

    return (
        <div>
            <Typography className={cn(styles.title)} type="title">
                {translate('OpenLinksThrough')}:
            </Typography>
            <div className={styles.radioButtons}>
                <Radio
                    label={translate('builtInBrowser')}
                    selected={p_.browserSettings.openBrowser === 'internal'}
                    className={styles.radio}
                    onClick={builtInBrowser}
                />
                <Radio
                    label={translate('externalBrowser')}
                    selected={p_.browserSettings.openBrowser === 'external'}
                    onClick={externalBrowser}
                />
            </div>
            {p_.platform !== 'android' && (
                <>
                    <Typography className={cn(styles.title)} type="title">
                        {translate('flags')}:
                    </Typography>
                    <div className={styles.checkboxSection}>
                        <Checkbox
                            label={translate('--ignore-gpu-blacklist_description')}
                            checked={p_.browserSettings.flags.includes('--ignore-gpu-blacklist')}
                            className={styles.checkboxWrapper}
                            onClick={(selected: boolean) => onChangeFlag(selected, '--ignore-gpu-blacklist')}
                            labelClassName={styles.labelClassName}
                        />
                        <Checkbox
                            label={translate('--enable-gpu-rasterization_description')}
                            checked={p_.browserSettings.flags.includes('--enable-gpu-rasterization')}
                            className={styles.checkboxWrapper}
                            onClick={(selected: boolean) => onChangeFlag(selected, '--enable-gpu-rasterization')}
                            labelClassName={styles.labelClassName}
                        />
                        <Checkbox
                            label={translate('--disable-web-security_description')}
                            checked={p_.browserSettings.flags.includes('--disable-web-security')}
                            className={styles.checkboxWrapper}
                            onClick={(selected: boolean) => onChangeFlag(selected, '--disable-web-security')}
                            labelClassName={styles.labelClassName}
                        />
                        <Checkbox
                            label={translate('--disable-features=AutoplayIgnoreWebAudio_description')}
                            checked={p_.browserSettings.flags.includes('--disable-features=AutoplayIgnoreWebAudio')}
                            className={styles.checkboxWrapper}
                            onClick={(selected: boolean) =>
                                onChangeFlag(selected, '--disable-features=AutoplayIgnoreWebAudio')
                            }
                            labelClassName={styles.labelClassName}
                        />
                    </div>
                </>
            )}
        </div>
    )
}

DeviceSettingsBrowserMode.defaultProps = {
    value: 'internal',
}

export default React.memo(DeviceSettingsBrowserMode)
